import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import dayjs from 'dayjs';
import { roundNumber } from '~/modules/@shared/helpers/roundNumber';

const CreateInvoiceSchema = z.object({
  member_id: z.coerce.number({ invalid_type_error: 'Required' }).min(1, { message: 'Required' }).optional(),
  amount: z.coerce
    .number({ invalid_type_error: 'Required' })
    .min(0.01, { message: 'Required' })
    .transform((x) => roundNumber({ value: x, decimals: 2 })),
  notes: z.string(),
  payment_category_type_id: z.number().min(1, { message: 'Required' }),
  taxable: z.boolean(),
  scheduled_date: z.string().refine((date) => dayjs(date).isValid(), {
    message: 'Invalid date format',
  }),
  total_amount: z.coerce.number().min(0.01),
  payment_method_id: z.union([z.number().min(0, { message: 'Required' }), z.literal('automatic_charge')]),
});

export type CreateInvoiceForm = z.infer<typeof CreateInvoiceSchema>;
export const createInvoiceResolver = zodResolver(CreateInvoiceSchema);

export const createInvoiceDefault: CreateInvoiceForm = {
  amount: 0,
  member_id: undefined,
  notes: '',
  payment_category_type_id: 0,
  taxable: false,
  scheduled_date: dayjs().format('YYYY-MM-DD'),
  total_amount: 0,
  payment_method_id: 0,
};
